module.exports = __webpack_public_path__ + "img/logo.66373250.svg";